import zenscroll from 'zenscroll';
import getScrollableElement from './get-scrollable-element';
import getScrollPosition from '../accessors/get-scroll-position';
import hooks from '../../hooks';

const SCROLL_MOMENTUM_TIME = 650;

let scrollInstance = null;

const setDocument = (document) => {
  const scrolledElement = getScrollableElement(document);
  scrollInstance = zenscroll.createScroller(scrolledElement);
  hooks.handlers.onAfterViewScrollerInitialized(document);
};

const smoothlyScrollInsideContainer = (container, position) =>
  new Promise((resolve, reject) => {
    if (typeof position === 'undefined' || !container) {
      reject(new Error('No scroller instance or container'));
    }

    const scroller = zenscroll.createScroller(container);

    scroller.toY(position, SCROLL_MOMENTUM_TIME, resolve);
  });

const scrollToPosition = (position, time = SCROLL_MOMENTUM_TIME) =>
  new Promise((resolve, reject) => {
    if (typeof position === 'undefined' || !scrollInstance) {
      reject(new Error('No scroller instance or position'));
    }
    const isOnPosition = getScrollPosition() === position;

    scrollInstance.toY(position, isOnPosition ? 0 : time, resolve);
  });

export default {
  setDocument,
  scrollToPosition,
  smoothlyScrollInsideContainer,
};
